export default "__VITE_ASSET__DtmjEYJH__"